import { POPUP_VISIBILITY_KEYS, USER_SETTINGS_KEYS } from '@/store';

export default {
  data: function () {
    return {
      isInfoPanelVisible: false,
      isInfoPanelWithCancel: false,
      isFirstRender: false,
      readyPages: [
        '/user/dashboard',
        '/user/filters',
        '/user/surveyHome',
        '/user/surveyForm',
        '/user/exchange',
        '/user/exchange/job-profile',
        '/recruiter',
        '/welcome',
      ],
    };
  },
  computed: {
    userSettingsKey: function () {
      if (this.$route.path === '/user/dashboard') {
        return USER_SETTINGS_KEYS.NOT_SHOW_INFO_DASHBOARD;
      }
      if (this.$route.path.startsWith('/user/filters')) {
        return USER_SETTINGS_KEYS.NOT_SHOW_INFO_FILTERS;
      }
      if (this.$route.path === '/user/surveyHome') {
        return USER_SETTINGS_KEYS.NOT_SHOW_INFO_STUDIES;
      }
      if (this.$route.path.startsWith('/user/surveyForm')) {
        return this.$route.params.surveyId
          ? `${USER_SETTINGS_KEYS.NOT_SHOW_INFO_STUDY_FORM}_${this.$route.params.surveyId}`
          : USER_SETTINGS_KEYS.NOT_SHOW_INFO_STUDY_FORM;
      }
      if (this.$route.path === '/user/exchange') {
        return USER_SETTINGS_KEYS.NOT_SHOW_INFO_EXCHANGE_DASHBOARD;
      }
      if (this.$route.path.startsWith('/user/exchange/job-profile')) {
        return USER_SETTINGS_KEYS.NOT_SHOW_INFO_JOB_PROFILE;
      }
      return null;
    },
    isInfoIconVisible: function () {
      return this.readyPages.some((path) => {
        return this.$route.path.startsWith(path);
      });
    },
  },
  methods: {
    showInfoPanelByButton: function () {
      this.isInfoPanelVisible = true;
      this.isInfoPanelWithCancel = false;
      this.isFirstRender = false;
    },
  },
};
